export default {
      id: "done-not-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#done-not",
      toString: function () {
        return this.url;
      }
    }